module.exports = __webpack_public_path__ + "img/ecotrin_81_mg_low_strength_tablets.5d20af00.png";